<div class="header-container">
    <span class="fs-20px font-weight-bold text-white">Plan Protection - {{folio}}</span>
    <span class="text-white fs-16px" style="cursor: pointer;" (click)="closeDialog()">
        <i class="fa-solid fa-square-xmark"></i>
    </span>
</div>
<div class="dialog-container">
    <form [formGroup]="planProtectionForm">
        <div class="col-12 mb-2">
            <div id="wizardContainer" class="nav-wizards-container">
                <nav class="nav nav-wizards-1 mb-2">
                    <div class="nav-item col">
                    <a class="nav-link " [ngClass]="{'active': step === 1, 'completed': step > 1, 'disabled': step < 1}">
                        <div class="nav-no">1</div>
                        <div class="nav-text">Datos del Contrato</div>
                    </a>
                    </div>
                    <div class="nav-item col">
                    <a class="nav-link " [ngClass]="{'active': step === 2, 'completed': step > 2, 'disabled': step < 2}">
                        <div class="nav-no">2</div>
                        <div class="nav-text">Datos del Cliente</div>
                    </a>
                    </div>

                    <div class="nav-item col">
                    <a class="nav-link " [ngClass]="{'active': step === 3, 'completed': step > 3, 'disabled': step < 3}">
                        <div class="nav-no">3</div>
                        <div class="nav-text">Datos del Auto</div>
                    </a>
                    </div>

                    <div class="nav-item col">
                    <a class="nav-link " [ngClass]="{'active': step === 4, 'completed': step > 4, 'disabled': step < 4}">
                        <div class="nav-no">4</div>
                        <div class="nav-text">Captura Identificación</div>
                    </a>
                    </div>
                    <!-- <div class="nav-item col">
                        <a class="nav-link " [ngClass]="{'active': step === 5, 'completed': step > 5, 'disabled': step < 5}">
                            <div class="nav-no">5</div>
                            <div class="nav-text">Captura Tacómetro</div>
                        </a>
                    </div> -->
                    <div class="nav-item col">
                        <a class="nav-link " [ngClass]="{'active': step === 5, 'completed': step > 5, 'disabled': step < 5}">
                            <div class="nav-no">5</div>
                            <div class="nav-text">Firmar</div>
                        </a>
                    </div>
                  
                </nav>
            </div>             
        </div>
        <div class="col-12">
            
            <fieldset *ngIf="step === 1" class="mb-4 fieldset-container">
                <legend class="custom-legend">Datos de Contrato</legend>               

                <div class="row">

                    <!-- <div class="col-4">
                        <span class="fs-14px font-weight-bold">Folio</span>
                        <input class="form-control" formControlName="folio" type="text" />
                    </div> -->
                   
                    <div class="col-12">
                        <span class="fs-14px font-weight-bold">Sucursal</span>
                        <input class="form-control"  formControlName="sucursal" type="text"/>
                    </div>

                    <div class="col-12">
                        <span class="fs-14px font-weight-bold">Orden Venta</span>
                        <input class="form-control" formControlName="ordenVenta" type="text" />
                    </div>
                                 
                </div>
                <div class="row mb-2">
                    

                    <div class="col-12">
                        <span class="fs-14px font-weight-bold">Sku</span>
                        <input class="form-control"  formControlName="sku" type="text"/>
                    </div>

                    <div class="col-12">
                        <span class="fs-14px font-weight-bold">Descripción</span>
                        <input class="form-control" formControlName="descripcion" type="text" />
                    </div>

                    <div class="col-12">
                        <span class="fs-14px font-weight-bold">Fecha Contratado</span>
                        <input class="form-control" formControlName="fechaContratado" type="text" />
                    </div>
                   
                    <div class="col-12">
                        <span class="fs-14px font-weight-bold">Fecha Expiración</span>
                        <input class="form-control" formControlName="fechaVigencia" type="text" disabled/>
                    </div>
                </div>
                
            </fieldset>

            <fieldset *ngIf="step === 2" class="mb-4 fieldset-container">
                
                <legend class="custom-legend mt-3">Datos de Cliente</legend>               

                <div class="row mb-2">
                    
                    <div class="col-12">
                        <span class="fs-14px font-weight-bold">Celular</span>
                        <input class="form-control" [ngClass]="{ 'is-invalid': errorsModel.celularCliente}" formControlName="celularCliente" type="text"/>
                    </div>

                    <div class="col-12">
                        <span class="fs-14px font-weight-bold">Nombre</span>
                        <input class="form-control" [ngClass]="{ 'is-invalid': errorsModel.nombreCliente}" formControlName="nombreCliente" type="text" />
                    </div>

                    <div class="col-12">
                        <span class="fs-14px font-weight-bold">Apellidos</span>
                        <input class="form-control" [ngClass]="{ 'is-invalid': errorsModel.apellidosCliente}" formControlName="apellidosCliente" type="text"/>
                    </div>

                    <div class="col-12">
                        <span class="fs-14px font-weight-bold">No. Cliente</span>
                        <input class="form-control" [ngClass]="{ 'is-invalid': errorsModel.noCliente}" formControlName="noCliente" type="text"/>
                    </div>
                    
                    <div class="col-12">
                        <span class="fs-14px font-weight-bold">Correo</span>
                        <input class="form-control" placeholder="Ingresa el correo eléctronico" [ngClass]="{ 'is-invalid': !validEmail, 'is-valid': validEmail}" (ngModelChange)="validarEmail($event)"  formControlName="correoCliente" type="text"/>
                    </div>

                </div>
                
            </fieldset>

            <fieldset *ngIf="step === 3" class="mb-4 fieldset-container">
                <legend class="custom-legend mt-3">Datos de Auto</legend>               

                <div class="row mb-2">
                    
                    <div class="col-12 h-66px">
                        <div class="d-flex w-100 flex-column">
                            <span class="fs-14px font-weight-bold">Marca</span>
                            <div class="btn-group">
                                <span class="form-control dropdown-toggle" [ngClass]="{ 'is-invalid': errorsModel.marca}" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    <img class="logo-marca" [src]="auto.logo" alt="">
                                    <span>{{auto.marca}}</span>
                                </span>
                                <ul class="dropdown-menu alto-maximo-dropdown">
                                    <li>
                                        <input type="text" formControlName="filtro" placeholder="Buscar marca...">
                                    </li>
                                    <li *ngFor="let marca of marcasFiltradas()" (click)="setCampoAuto('marca', marca.name, marca.slug, marca.logo)" class="d-flex flex-row">
                                        <img class="logo-marca" [src]="marca.logo" alt="">
                                        <span class="ms-2">{{marca.name}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                   
                    
                </div>

                
                 <div class="row mb-2">
                    
                    
                    <div class="col-12">
                        <span class="fs-14px font-weight-bold">Modelo</span>
                        <select class="form-control"  [ngClass]="{ 'is-invalid': errorsModel.modelo}" name="model" id="model" [disabled]="modelDisabled" (change)="setCampoAuto('modelo', $event, $event)">
                            <option value="">Selecciona un Modelo</option>
                            <option *ngFor="let model of modelos" [value]="model.name">{{model.name}}</option>
                        </select>
                    </div>
                    
                    <div class="col-12">
                        <span class="fs-14px font-weight-bold">Año</span>
                        <select class="form-control" [ngClass]="{ 'is-invalid': errorsModel.ano}" name="cars" id="cars" [disabled]="yearDisabled" (change)="setCampoAuto('year', $event, $event)">
                            <option value="">Selecciona un Año</option>
                            <option *ngFor="let year of years" [value]="year.name">{{year.name}}</option>
                        </select>
                    </div>


                    <div class="col-12">
                        <span class="fs-14px font-weight-bold">Kilometraje</span>
                        <div class="d-flex flex-row align-items-center">
                            <input class="form-control" placeholder="Ingresa Kilometraje del auto" [ngClass]="{ 'is-invalid': errorsModel.kilometraje}" formControlName="kilometraje" formatearMiles type="text" inputmode="numeric" (keydown)="limpiarCaracteresNoNumericos($event)" (keypress)="soloNumeros($event)"/>
                            <button *ngIf="base64tacometro === undefined" class="btn btn-danger ms-2" (click)="seleccionarOpcionEvidencia(1)"><i class="fa-solid fa-camera fs-16px"></i></button>
                            <button *ngIf="base64tacometro !== undefined" class="btn btn-success ms-2" (click)="seleccionarOpcionEvidencia(1)"><i class="fa-solid fa-check fs-16px"></i></button>
                        </div>
                    </div>
                   
                    <div class="col-12">
                        <span class="fs-14px font-weight-bold">Placas</span>
                        <div class="d-flex flex-row align-items-center">
                            <input class="form-control" placeholder="Ingresa Placas del auto" [ngClass]="{ 'is-invalid': errorsModel.placas}" formControlName="placas" placasFormat type="text"/>
                            <button *ngIf="base64Placas === undefined" class="btn btn-danger ms-2" (click)="seleccionarOpcionEvidencia(2)"><i class="fa-solid fa-camera fs-16px"></i></button>
                            <button *ngIf="base64Placas !== undefined" class="btn btn-success ms-2" (click)="seleccionarOpcionEvidencia(2)"><i class="fa-solid fa-check fs-16px"></i></button>
                        </div>
                    </div>
                    
                    <div class="col-12">
                        <span class="fs-14px font-weight-bold">No. Serie</span>
                        <div class="d-flex flex-row align-items-center">
                            <input class="form-control" placeholder="Ingresa el no. serie del auto" [ngClass]="{ 'is-invalid': errorsModel.noSerie}" formControlName="noSerie" type="text"/>
                            <button *ngIf="base64NoSerie === undefined" class="btn btn-danger ms-2" (click)="seleccionarOpcionEvidencia(3)"><i class="fa-solid fa-camera fs-16px"></i></button>
                            <button *ngIf="base64NoSerie !== undefined" class="btn btn-success ms-2" (click)="seleccionarOpcionEvidencia(3)"><i class="fa-solid fa-check fs-16px"></i></button>
                        </div>
                    </div>
                    <!-- Input oculto para seleccionar imagen -->
                        <input
                        type="file"
                        accept="image/*"
                        #fileInput
                        style="display: none"
                        (change)="procesarImagenGaleria($event)"
                        />

                        <input
                        type="file"
                        accept="image/*"
                        #fileInput2
                        style="display: none"
                        (change)="procesarImagenGaleria($event)"
                        />

                        <input
                        type="file"
                        accept="image/*"
                        #fileInput3
                        style="display: none"
                        (change)="procesarImagenGaleria($event)"
                        />
                        
                </div>
                
            </fieldset>

            <fieldset *ngIf="step === 4" class="mb-4 fieldset-container">
                <legend class="custom-legend">Captura de Identificación</legend>
                <app-webcam (imageCaptured)="onImage($event)" [opcion]="1" (capturaReiniciada)="desactivarContinuar($event)"></app-webcam>

            </fieldset>

            <!-- <fieldset *ngIf="step === 5" class="mb-4 fieldset-container">
                <legend class="custom-legend">Captura de Tacómetro</legend>
                <app-webcam (imageCaptured)="onImage($event)" [opcion]="2" (capturaReiniciada)="desactivarContinuar($event)"></app-webcam>
            </fieldset> -->
            
            <fieldset *ngIf="step === 5" class="mb-4 fieldset-container">
                <legend class="custom-legend">Firma</legend>
                <div (click)="abrirPdf()" class="d-flex flex-column align-items-center mt-2 mb-2">
                    <span>Da click aquí para previsualizar el documento.</span>
                    <i class="fa-solid fa-file-pdf fs-40px"></i>
                </div>
                <app-signature-pad (signatureSaved)="onSignature($event)" (cleanSignature)="limpiarFirma()"></app-signature-pad>
            </fieldset>

            <div class="d-flex flex-row justify-content-end">
                <button *ngIf="step > 1" (click)="backStep()" class="btn btn-secondary">Regresar</button>
                <button *ngIf="step < 4" (click)="validateStep(1)" class="btn btn-primary ms-2">Continuar</button>
                <button *ngIf="step === 4 && base64ine !== undefined" (click)="validateStep(1)" class="btn btn-primary ms-2">Continuar</button>
                <!-- <button *ngIf="step === 5 && base64tacometro !== undefined" (click)="validateStep(1)" class="btn btn-primary ms-2">Continuar</button> -->
                <div *ngIf="!subirArchivosCarrete">
                    <button *ngIf="step === 5 && tieneFirma" (click)="confirmarGuardar()" class="btn btn-primary ms-2">Guardar</button>
                </div>
                <div *ngIf="subirArchivosCarrete">
                    <button *ngIf="step === 5" (click)="confirmarGuardar()" class="btn btn-primary ms-2">Guardar</button>
                </div>
                <!-- <button *ngIf="step === 4" (click)="guardarProveedor()" class="btn btn-primary ms-2">Guardar Cambios a Proveedor</button> -->
            </div>
        </div>
    </form>
</div>